// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"3c6c31df","922":"4fbaf809","948":"c44bb047"}[chunkId] + ".chunk.css";
};